var _style, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 187.8 187.8",
    style: {
      enableBackground: "new 0 0 187.8 187.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:url(#SVGID_00000070111209933374605510000003234414785175840919_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 90.0573,
    cy: 50.6394,
    r: 143.4856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3CA2FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F56EC"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 94.6,
    cy: 94.9,
    r: 90.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.620079e-02 -0.9989 0.9989 4.620079e-02 -51.4964 148.2037)",
    className: "st1",
    cx: 51.9,
    cy: 101.1,
    rx: 30.7,
    ry: 13.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.7,109.1c-0.7,3.4-2.3,5.4-3.9,6.5c-0.2,0.1-0.4,0.3-0.6,0.4c-0.2,0.1-0.7,0.4-1.3,0.6 c-0.1,0-0.1,0.1-0.1,0.1c-0.4,0.2-0.8,0.4-1.2,0.4c-0.3,0.1-0.6,0.1-0.7,0c2.2,1.7,2,5.3,0.9,7.6c-0.8,1.6-2.1,3-3.6,3.8 c-1.5,0.8-3,1.2-4.7,1.1c0,2.2-1.2,4.3-3.2,5.4c-10.4,6-24.2,3.5-35.5,2.5c-0.8-0.1-1.6-0.1-2.3-0.2c-5.4-0.4-10.9-1-15.8-3.7 c-11.3-6.1-9.7-19.4-9.1-30.2c0.3-4.6,0.5-9.3,0.9-13.9c0.6-8.3,2.1-16.1,9.9-20.5c5.7-3.2,14.8-5,17.6-11.7 c4.1-9.9-2.6-24.5,7.9-26c10.5-1.5,24.4,13.4,17.3,26.6c-7.1,13.2-11.3,14.3-4.4,16.6c9.9,3.2,26.2-3.6,31,9.3 c1.4,3.8,1.6,9.3-1.7,12.3c-0.8,0.7-1.7,1.1-1,2c0,0,0,0,0,0c0.5,0.6,1,1.1,1.7,1.5C150.3,101.4,151.7,104.4,150.7,109.1z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000027599787664721147900000015872938686061435800_",
    cx: 135.7491,
    cy: 116.1367,
    r: 0.7577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3CA2FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F56EC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027599787664721147900000015872938686061435800_)"
    },
    d: "M136.6,116c-0.4,0.2-0.7,0.3-1,0.4 c-0.4,0-0.6,0-0.6,0S135.7,116.4,136.6,116z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike01);
export default __webpack_public_path__ + "static/media/like-01.c67f711d5a482c027ce19e7f3e35d2d3.svg";
export { ForwardRef as ReactComponent };